/**
 * IPC 设计 Token（权威来源：产品原型）
 *
 * - `D:/Users/user/Downloads/ipc原型/colors_and_type.css`
 * - `ipc原型/UI-STANDARDS-SPEC.md`
 *
 * antd 使用 hex；自定义 DOM 使用 `--ipc-*` / `--color-*`（见 index.css）
 */
export const ipcTokens = {
  /** shadcn Blue primary — hsl(221.2 83.2% 53.3%) */
  primary: '#3B82F6',
  primaryHover: '#2563EB',
  primaryActive: '#1D4ED8',
  primaryForeground: '#F8FAFC',
  primaryBg: 'rgba(59, 130, 246, 0.12)',
  primaryBgHover: 'rgba(59, 130, 246, 0.18)',

  /** hsl(222.2 84% 4.9%) */
  foreground: '#020817',
  /** #FFFFFF */
  background: '#FFFFFF',
  card: '#FFFFFF',

  /** hsl(210 40% 96.1%) — 表头等 */
  muted: '#F1F5F9',
  /** hsl(215.4 16.3% 46.9%) */
  mutedForeground: '#64748B',

  border: '#E2E8F0',
  input: '#E2E8F0',
  ring: '#3B82F6',

  destructive: '#EF4444',
  destructiveBg: 'rgba(239, 68, 68, 0.12)',

  success: '#22C55E',
  successBg: 'rgba(34, 197, 94, 0.12)',
  warning: '#F59E0B',
  warningBg: 'rgba(245, 158, 11, 0.12)',

  /** 顶栏 — hsl(222.2 84% 4.9%) */
  sidebar: '#020817',
  sidebarForeground: '#F8FAFC',
  sidebarAccent: '#1E293B',

  /** 排版：原型基准 text-sm = 14px，页面标题 text-xl = 20px */
  fontFamily:
    "Inter, -apple-system, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI', 'Segoe UI', sans-serif",
  fontSize: 14,
  fontSizeSm: 12,
  fontSizeXs: 12,
  fontSizeLg: 16,
  fontSizeXl: 20,
  fontSizePageTitle: 20,
  lineHeight: 1.5,
  lineHeightSm: 1.25,

  /** 控件 h-9 = 36px；圆角 --radius = 0.5rem = 8px */
  radius: 8,
  radiusSm: 4,
  radiusMd: 6,
  radiusLg: 8,
  controlHeight: 36,
  controlHeightSm: 32,
  controlHeightLg: 40,

  /** 壳层 */
  headerHeight: 56,
  contentPadding: 20,

  /** 阴影：原型静态卡片以 border 为主，弹层 shadow-md */
  shadowPopover: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1)',
  shadowCard: 'none',

  rowHoverPrimary: 'rgba(59, 130, 246, 0.05)',
} as const;

export type IpcTokens = typeof ipcTokens;
